import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/review/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/review/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/review/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/review/submit', params, options);

export const update = (params, options) => request.post('/api/review/submit', params, options);

export const addReview = (params, options) =>
  request.post('/api/review/addReview', params, options);
